import Reports from './Reports'
import * as selectors from './reports.selectors'
import * as asyncActions from './reports.asynActions'
import slice from './reports.slice'

export const {
	name,
	actions: { setReportFilters },
	reducer,
} = slice

export const { fetchTotals, fetchCommission, fetchTotalsAdditional, createFastBoundDeltaReport } =
	asyncActions

export const { selectTotals, selectComission } = selectors

export default Reports
